import React from 'react';
import {withContext, getContext} from 'recompose';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';

export class RoutingDecorator {

    constructor(routing, routes) {
        this.routing = routing;
        this.routes = routes;

        this.generate = this.generate.bind(this);
    }

    generate(route, params) {
        if (route in this.routes) {
            let newRoute = this.routes[route];

            if (params) {
                Object.keys(params).forEach((key) => {
                    newRoute = newRoute.replace(`{{${key}}`, params[key]);
                });
            }

            return newRoute;
        }

        return this.routing.generate(route, params);
    }
}

export const RoutingProvider = withContext(
    {
        routing: PropTypes.shape({
            generate: PropTypes.func.isRequired,
        }),
    },
    ({routing}) => ({routing}),
)(({children}) => React.Children.only(children));

export const withRouting = getContext({
    routing: PropTypes.shape({
        generate: PropTypes.func.isRequired,
    }),
});

export const Link = withRouting((props) => {

    const anchorProps = omit(props, ['children', 'routing', 'href', 'route', 'params']);

    return (
        <a href={props.routing.generate(props.route, props.params)} {...anchorProps}>{props.children}</a>
    );
});
